document.addEventListener('DOMContentLoaded', init, false);
function init(){
  const revProductContainers = document.getElementById('rev_slider');
  const revPreBtn = document.getElementById('rev_pre-btn');
  const revNxtBtn = document.getElementById('rev_nxt-btn');
  
  revNxtBtn.addEventListener('click', event =>{
    let containerWidth = revProductContainers.getBoundingClientRect().width;
    revProductContainers.scrollLeft += containerWidth;
  })

  revPreBtn.addEventListener('click', event =>{
    let containerWidth = revProductContainers.getBoundingClientRect().width;
    revProductContainers.scrollLeft -= containerWidth;
  })
}